module.exports = __webpack_public_path__ + "img/bm.f267ab85.svg";